import { render, staticRenderFns } from "./ListDetails.vue?vue&type=template&id=89405984&"
import script from "./ListDetails.vue?vue&type=script&lang=js&"
export * from "./ListDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports